module.exports = __webpack_public_path__ + "media/assets/icons/triangle1-6d1ca99ebed9d044a120bde89e93db5f.svg";